import { Category } from '@shared/types/product/Category';
import { Category as EntityCategory } from '@/types/entity/category';
import { Locale } from '@/project.config';
import { resolveLocalizedUrl } from '@/utils/resolve-localized-url';

export const mapCategory = (category: Category, { locale = 'en-AU' }: { locale?: Locale } = {}): EntityCategory => {
  return {
    categoryId: category.categoryId ?? '',
    categoryKey: category.slug,
    name: category.name ?? '',
    description: category.description || undefined,
    // EWM-854 — resolve with a fallback, not a bare index: the shared AU/NZ
    // catalogue is slugged in en-AU only, so an `en-NZ` index yielded '' and
    // wiped the PDP breadcrumb trail on the whole NZ storefront.
    path: resolveLocalizedUrl(category._url, locale),
    paths: Object.fromEntries(
      Object.entries(category._url ?? {}).flatMap(([key, value]) => [
        [key, value],
        [key.split('-')[0], value],
        [key.toLowerCase(), value],
      ]),
    ),
    descendants: category.descendants?.map((c) => mapCategory(c, { locale })) ?? [],
    // EWM-539 — ordered ancestor chain (root-first) for breadcrumbs.
    ancestors: category.ancestors?.map((a) => ({ categoryId: a.categoryId ?? '', name: a.name ?? '' })),
  };
};
